import React, { useCallback } from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale/index';
import { Icon, Button, Hr } from 'LocalGluons';

import portraitStyles, { landscapeStyles } from './NotificationDialog.jss';

const NotificationDialog = ({ onWatchPress, close, text, isLandscape }) => {
    const styles = isLandscape ? landscapeStyles : portraitStyles;
    const buttonStyle = { button: styles.button };
    const onWatch = useCallback(() => {
        onWatchPress();
        close();
    }, []);

    return (
        <View style={styles.window}>
            <View style={styles.closeIconContainer}>
                <Icon style={styles.closeIcon} name="close" onPress={close} />
            </View>
            <View>
                <View style={styles.alarmIconContainer}>
                    <Icon style={styles.bellIcon} name="alarm" />
                </View>
                <Text style={styles.title}>{t('REMIND.TITLE')}</Text>
            </View>
            <Hr />
            <Text style={styles.greyText} numberOfLines={10}>
                {text}
            </Text>
            <View style={styles.buttonContainer}>
                <Button
                    style={buttonStyle}
                    title={t('REMIND.BTN_CANCEL')}
                    onPress={close}
                    isSecondary
                />
                <Button style={buttonStyle} title={t('REMIND.BTN_WATCH')} onPress={onWatch} />
            </View>
        </View>
    );
};

NotificationDialog.defaultProps = {
    isLandscape: false
};

NotificationDialog.propTypes = {
    text: PropTypes.string.isRequired,
    onWatchPress: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    isLandscape: PropTypes.bool
};

export default NotificationDialog;
